import { jsx as _jsx } from "react/jsx-runtime";
import { Flex, ActivityIndicator, RichText, SidebarPageContent } from '@phishtool/ui';
import { knowledgeBaseArticleService } from '~service';
const KnowledgeBaseArticle = ({ contentId }) => {
    const { data, isLoading } = knowledgeBaseArticleService.useGetKnowledgeBaseArticle({
        knowledgeBaseArticleId: contentId,
    });
    return isLoading ? (_jsx(Flex, { width: "100%", height: "100%", align: "center", justify: "center", children: _jsx(ActivityIndicator, { size: 50 }) })) : (_jsx(SidebarPageContent, { large: true, children: _jsx(RichText, { data: data }) }));
};
export default KnowledgeBaseArticle;
